// extracted by mini-css-extract-plugin
module.exports = {"loadingInner":"Loading_loadingInner__ZTPbY","spinner":"Loading_spinner__RjJIf","loading":"Loading_loading__wvsgk"};